export default __webpack_public_path__ + "static/bratz-x-bb-desktop-0c48d4f7b3a4a6abb3b32e7b8eea3b46.webp";